import { PiFacebookLogoDuotone, PiInstagramLogoDuotone, PiTiktokLogoDuotone, PiYoutubeLogoDuotone, PiSpotifyLogoDuotone } from 'react-icons/pi';

export default function SocialList(props) {
    const items = [
        { 'className': 'gradient-blue', 'icon': <PiFacebookLogoDuotone />, 'label': 'Facebook', 'url': 'https://www.facebook.com/furgediak' },
        { 'className': 'gradient-yellow', 'icon': <PiInstagramLogoDuotone />, 'label': 'Instagram', 'url': 'https://www.instagram.com/furge.diak/' },
        { 'className': 'bg-gradient-to-br from-[#69c9d0] to-[#ee1d52]', 'label': 'TikTok', 'icon': <PiTiktokLogoDuotone />, 'url': 'https://www.tiktok.com/@furge.diak' },
        { 'className': 'gradient-red', 'icon': <PiYoutubeLogoDuotone />, 'label': 'YouTube', 'url': 'https://www.youtube.com/furgediakvideo' },
        { 'className': 'gradient-green', 'icon': <PiSpotifyLogoDuotone />, 'label': 'Spotify', 'url': 'https://open.spotify.com/show/3B8MUdfRxPjpCVGNDoYb2k' },
    ];

    return (
        <div className={'flex flex-row gap-3 ' + (props.className || '')}>

            {items.map((item) => <Item key={item.url} data={item} />)}

        </div>
    );
}

function Item(props) {
    return (
        <a href={props.data.url} target='_blank' rel='noreferrer' className={'relative size-10 rounded-xl bg-white/10 flex items-center justify-center hover:ring-4 ring-white/20 active:scale-95 transition overflow-hidden group ' + (props.data.classNamee)}>

            <div className={'absolute top-0 left-0 w-full h-full opacity-0 group-hover:opacity-100 transition ' + (props.data.className || '')} />

            <div className='text-2xl z-10 text-white'>{props.data.icon}</div>

        </a>
    );
}